import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
    TextField,
    Text,
    Stack,
    StackItem,
    ITextFieldStyles,
} from '@fluentui/react';
import ButtonPrimaryComponent from '../../components/button-primary/button-primary.component';
import ErrorMessageComponent from '../../components/error-message/error-message.component';
import LoaderComponent from '../../components/loader/loader.component';
import SuccessMessageComponent from '../../components/success-message/success-message.component';

import ItemCliente from '../../models/ItemCliente';
import useAuthStatus from '../../hooks/auth/AuthHook';

const textFieldStyles : ITextFieldStyles = {
    root: {},
    fieldGroup: {
        borderColor: 'var(--color-primario)',
        borderRadius: 5,
        selectors: {
            "&:hover, &:focus, &:active": {
                borderColor: 'var(--color-primario)',
                borderRadius: 5,
            },
        },
    },
    prefix: {},
    suffix: {},
    field: {},
    icon: {},
    description: {},
    wrapper: {},
    errorMessage: {},
    subComponentStyles: {
        label: {},
    },
    revealButton: {},
    revealSpan: {},
    revealIcon: {},
};

interface IRecoverPasswordPageProps {};

const RecoverPasswordPage = (props: IRecoverPasswordPageProps) => {
    const auth = useAuthStatus();

    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<string>('');
    const [customer, setCustomer] = useState<ItemCliente>(new ItemCliente());
    const [loading, setLoading] = useState<boolean>(false);

    const onChangeEmail = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) : void => {
        setCustomer({ 
            ...customer, 
            Email: newValue ? newValue : "",
        });
    };

    const onKeyUp = (event: React.KeyboardEvent) : void => {
        if (event.key === "Enter") {
            onRecover();
        }
    };

    const onRecover = () : void => {
        setError('');
        if (customer.Email === "") {
            setError("Alguno de los campos introducidos no es válido.");
        }
        else {
            setLoading(true);
            auth.recover(customer).then((response: string) => {
                setCustomer({ 
                    ...customer, 
                    Email: "",
                });
                setSuccess(response);
                setLoading(false);
            }, (error: string) => {
                setError(error);
                setLoading(false);
            });
        }
    };

    return (
        <>
            <Stack>
                <StackItem className='mb-3'>
                    <Text 
                        className='fw-bold'
                        variant='large'>
                        Recuperar contraseña:
                    </Text>
                </StackItem>
                <StackItem className='mb-3'>
                    <Text>
                        ¿Olvidaste tu contraseña? Introduce tu dirección de correo electrónico para MyMov y te enviaremos un código para restablecer tu 
                        contraseña.
                    </Text>
                </StackItem>
                <StackItem className='mb-3'>
                    <TextField
                        type="email"
                        autoComplete="on"
                        maxLength={100}
                        onChange={onChangeEmail}
                        defaultValue={customer.Email}
                        label="Correo electrónico"
                        styles={textFieldStyles}
                        onKeyUp={onKeyUp} />
                </StackItem>
                <StackItem className='mb-3'>
                    <Stack 
                        horizontal={true}
                        className="d-flex align-items-center justify-content-between">
                        <StackItem>
                            <ButtonPrimaryComponent 
                                className='text-uppercase'
                                text='Recuperar'
                                onClick={onRecover} />
                        </StackItem>
                        <StackItem className="flex-fill text-center align-items-center">
                            <Link 
                                to="/"
                                style={{
                                    color: 'var(--color-primario)',
                                    textDecoration: 'none',
                                }}>
                                Iniciar sesión
                            </Link>
                        </StackItem>
                    </Stack>
                </StackItem>
                <StackItem className='mb-3'>
                    <ErrorMessageComponent message={error} />
                    <SuccessMessageComponent message={success} />
                </StackItem>
            </Stack>
            <LoaderComponent loading={loading} />
        </>
    );
};

export default RecoverPasswordPage;
